export default __webpack_public_path__ + "static/media/dropdown_arrow_up.bbbed29a.svg";